export const CardPointeFundingOutcome = {
    AVAILABLE: 'available',
    UNAVAILABLE: 'unavailable',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CardPointeFundingOutcome =
    (typeof CardPointeFundingOutcome)[keyof typeof CardPointeFundingOutcome];

export type CardPointeFundingScalar = string | number | null;

export type CardPointeFundingRecord = Readonly<Record<string, unknown>>;

export interface CardPointeFundingRequestQuery {
    readonly merchid: string;
    readonly date: string;
    readonly page?: string;
    readonly limit?: string;
}

export interface CardPointeFundingRequestDetails {
    readonly method: 'GET';
    readonly path: '/cardconnect/rest/funding';
    readonly query: CardPointeFundingRequestQuery;
}

export interface CardPointeFundingTransaction {
    readonly fundingtxnid?: CardPointeFundingScalar;
    readonly retref?: string;
    readonly authcode?: string;
    readonly authdate?: CardPointeFundingScalar;
    readonly respcode?: string;
    readonly batchid?: CardPointeFundingScalar;
    readonly cardproc?: string;
    readonly interchangeunitfee?: string;
    readonly interchangepercentfee?: string;
    readonly date?: CardPointeFundingScalar;
    readonly cardnumber?: string;
    readonly cardtype?: string;
    readonly cardbrand?: string;
    readonly amount?: string;
    readonly currency?: string;
    readonly type?: string;
    readonly status?: string;
    readonly fundingid?: CardPointeFundingScalar;
    readonly invoicenumber?: string;
    readonly sourcetransactionid?: string;
    readonly terminalnumber?: string;
    readonly achreturncode?: string;
    readonly parentretref?: string;
}

export interface CardPointeFundingResponseBody {
    readonly fundings?: readonly CardPointeFundingRecord[];
    readonly txns?: readonly CardPointeFundingTransaction[];
    readonly adjustments?: readonly CardPointeFundingRecord[];
    readonly chargebacks?: readonly CardPointeFundingRecord[];
    readonly pageNumber?: CardPointeFundingScalar;
    readonly perPageSize?: CardPointeFundingScalar;
    readonly currentPageSize?: CardPointeFundingScalar;
    readonly fundingdate?: CardPointeFundingScalar;
    readonly merchid?: string;
    readonly datechanged?: CardPointeFundingScalar;
    readonly fundingmasterid?: CardPointeFundingScalar;
    readonly errormsg?: string;
}

export interface CardPointeFundingTransactionSummary {
    readonly gateway_txn_id: string;
    readonly amount?: string;
    readonly currency?: string;
    readonly transaction_type?: string;
    readonly settlement_status?: string;
    readonly authorization_code?: string;
    readonly batch_id?: string;
    readonly funding_id?: string;
    readonly funding_transaction_id?: string;
}

export interface CardPointeFundingSummary {
    readonly merchant_id: string;
    readonly funding_date?: string;
    readonly funding_master_id?: string;
    readonly transaction_count: number;
    readonly transactions: readonly CardPointeFundingTransactionSummary[];
    readonly matched_transaction?: CardPointeFundingTransactionSummary;
}

export type CardPointeFundingResponseDetails =
    | {
          readonly outcome: typeof CardPointeFundingOutcome.AVAILABLE;
          readonly httpStatus: 200;
          readonly body: CardPointeFundingResponseBody;
          readonly summary: CardPointeFundingSummary;
      }
    | {
          readonly outcome: typeof CardPointeFundingOutcome.UNAVAILABLE;
          readonly httpStatus: number;
          readonly body: unknown;
          readonly message: string;
      }
    | {
          readonly outcome: typeof CardPointeFundingOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly body: unknown;
          readonly message: string;
      };
